import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  isOpenModal: false,
  modalData: null,
  endingTime: null,
  startingTime: null,
  userDetails: undefined,
  latestBreak: undefined,
  lastSession: undefined,
  roleDetails: undefined,
  notificationDetails: [],
  stopwatchState: {
    hours: 0,
    minutes: 0,
    seconds: 0,
    isRunning: false,
  },
  dispositionModal: {
    isOpen: false,
    data: null, 
  },
  callStarted: false,
  apiResponse: {}
};

export const LoginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    setLogin: (state, action) => {
      state.isLoggedIn = action.payload;
    },
    setRole: (state, action) => {
      state.roleDetails = action.payload;
    },
    setUserDetails: (state, action) => {
      state.userDetails = action.payload;
    },
    setLatestBreak: (state, action) => {
      state.latestBreak = action.payload;
    },
    setLastSession: (state, action) => {
      state.lastSession = action.payload;
    },
    setNotification: (state, action) => {
      state.notificationDetails = [
        ...(state.notificationDetails || []),
        action.payload,
      ];
    },
    clearNotifications: (state) => {
      state.notificationDetails = [];
    },
    openModal: (state, action) => {
      state.isOpenModal = action.payload.isOpenModal;
      state.modalData = action.payload.modalData;
    },
    startingTime: (state, action) => {
      state.startingTime = action.payload.startingTime;
    },
    endingTime: (state, action) => {
      state.endingTime = action.payload.endingTime;
    },
    setStopwatchState: (state, action) => {
      state.stopwatchState = action.payload;
    },
    setCallingStarted: (state, action) => {
      state.callStarted = action.payload;
    },
    setDispositionalModal: (state, action) => {
      state.dispositionModal = {
        ...state.dispositionModal,
        ...action.payload
      };
    },
    setApiResponsed: (state, action) => {
      state.apiResponse = action.payload;
    }, 
    resetCallState: (state) => {
      state.isOpenModal = false;
      state.modalData = null;
      state.startingTime = null;
      state.endingTime = null;
      state.stopwatchState = { hours: 0, minutes: 0, seconds: 0, isRunning: false };
      state.callStarted = false;
      state.dispositionModal = { isOpen: false, data: null };
      state.apiResponse = {};
    }, 
  },
});

export const {
  setLogin,
  setUserDetails,
  setLastSession,
  setLatestBreak,
  setRole,
  setNotification,
  clearNotifications,
  openModal,
  startingTime,
  endingTime,
  setStopwatchState,
  setCallingStarted,
  setDispositionalModal,
  setApiResponsed,
  resetCallState
} = LoginSlice.actions;

export default LoginSlice.reducer;
